export default __webpack_public_path__ + "static/blob10-82983464f88c60d11f883dca506494da.svg";